import { InputAdornment, TextField } from "@mui/material";

import { isValueless, type NumericComparator } from "../FilterSchema";

interface NumericValueInputProps {
  comparator: NumericComparator;
  value: number[];
  onChange: (next: number[]) => void;
  /** Optional unit of measure (e.g. "%", "ms"), shown as an end adornment inside
   *  the input so the entered value reads with its unit. Omitted/`null` renders
   *  no adornment. */
  unit?: string | null;
}

export function NumericValueInput({
  comparator,
  value,
  onChange,
  unit = null,
}: NumericValueInputProps) {
  const valueless = isValueless(comparator);

  if (valueless) {
    return null;
  }

  const text = value.length === 1 ? value[0].toString() : "";
  return (
    <TextField
      type="number"
      autoFocus
      size="small"
      fullWidth
      placeholder="Enter number..."
      value={text}
      onChange={(event) => {
        const raw = event.target.value;
        if (raw === "") {
          onChange([]);
          return;
        }
        const parsed = Number(raw);
        if (Number.isFinite(parsed)) {
          onChange([parsed]);
        }
      }}
      InputProps={
        unit
          ? {
              endAdornment: (
                <InputAdornment position="end">{unit}</InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
}
